import * as React from 'react';

interface FootnoteProps {
  className?: string;
  dataHook?: string;
  footnote?: React.ReactNode;
}

export declare const Footnote: React.FunctionComponent<FootnoteProps>;
